import React from 'react';
import style from './ChoicePage.module.css';
import { useNavigate } from 'react-router-dom';
import {
	MdAutoAwesome,
	MdAdd,
	MdSearch,
	MdFitnessCenter,
	MdArrowForward,
	MdCalendarMonth,
} from 'react-icons/md';

const options = [
	{
		id: 'my-routines',
		icon: MdFitnessCenter,
		title: 'My Routines',
		description: 'View and manage your saved routines, track progress, and pick up where you left off.',
		path: '/profile-page',
		accent: 'var(--text-primary)',
	},
	{
		id: 'generate',
		icon: MdAutoAwesome,
		title: 'Generate Routine',
		description: 'Let AI create a personalized single workout routine based on your goals and preferences.',
		path: '/interests',
		accent: 'var(--accent)',
	},
	{
		id: 'create',
		icon: MdAdd,
		title: 'Create Routine',
		description: 'Build your own routine from scratch. Full control over every exercise, set, and rep.',
		path: '/add-routine',
		accent: 'var(--info)',
	},
	{
		id: 'find',
		icon: MdSearch,
		title: 'Find Routine',
		description: 'Browse routines from the community and find one that fits your goals and schedule.',
		path: '/explore-routines',
		accent: 'var(--warning)',
	},
	{
		id: 'workout-plan',
		icon: MdCalendarMonth,
		title: 'Workout Plan',
		description: '7-, 14-, or 30-day AI plans. Multi-day structure, one place.',
		path: '/plan-builder',
		accent: 'var(--accent)',
	},
];

const ChoicePage = () => {
	const navigate = useNavigate();

	return (
		<div className={style.ChoicePage}>
			<div className={style.Header}>
				<h1 className={style.Heading}>Workouts</h1>
				<p className={style.Subheading}>
					Start a new routine or pick up where you left off.
				</p>
			</div>

			<div className={style.OptionsGrid}>
				{options.map((opt) => (
					<button
						key={opt.id}
						className={`${style.OptionCard} ${opt.isNew ? style.Featured : ''} ${opt.comingSoon ? style.ComingSoon : ''}`}
						onClick={() => !opt.comingSoon && navigate(opt.path)}
						disabled={opt.comingSoon}
						aria-disabled={opt.comingSoon}
					>
						{opt.isNew && <span className={style.NewBadge}>New</span>}
						{opt.comingSoon && <span className={style.ComingSoonBadge}>Coming soon</span>}

						<div className={style.IconWrapper} style={{ '--card-accent': opt.accent }}>
							<opt.icon />
						</div>

						<div className={style.CardContent}>
							<h3 className={style.CardTitle}>{opt.title}</h3>
							<p className={style.CardDescription}>{opt.description}</p>
						</div>

						{!opt.comingSoon && (
							<div className={style.CardArrow}>
								<MdArrowForward />
							</div>
						)}
					</button>
				))}
			</div>
		</div>
	);
};

export default ChoicePage;
